import React, { PureComponent } from "react";
import { Input, Select, Table, Checkbox, Button, Dialog } from "element-react";
import Http from "../../networkReq/http"
import Request from "../../networkReq/request";
import download from "images/preferential/download.png";
import flowImg from "images/preferential/flowImg.png";
import { showhtml } from 'utils/methods'
import "./applicationGuide.css";

export default class ApplicationGuide extends PureComponent {
  state = {
    departmentTyprs: [
      { value: '1', label: '事业单位' },
      { value: '2', label: '机关' },
      { value: '3', label: '政府部门' },
    ],
    dealForms: [
      { value: '1', label: '窗口办理' },
      { value: '2', label: '在线办理' },
    ],
    value: "",
    materialsList: [],
    smsEntitledGroups: "",
    dialogVisible: false
  };


  componentDidMount = () => {
    const {
      location: { search }
    } = this.props;
    const id = search.substring(1);

    Http.get(Request.getItemsDetail(), { id }, obj => {
      console.log('obj', obj)
      if (obj && obj.code == 200) {
        const data = obj.data;
        this.setState({
          smsEntitledGroups: data.smsEntitledGroups,
          materialsList: data.materialsList
        });
      }
    });

  };

  returnType(typeList, type) {
    for (var i = 0; i < typeList.length; i++) {
      if (typeList[i].value == type) {
        return typeList[i].label
      }
    }
  }




  handleClick = () => {
    this.setState({
      dialogVisible: true
    })
  }

  render() {
    const { smsEntitledGroups, materialsList } = this.state;
    const columns = [
      {
        type: "index",
        label: "序号",
        width: '100',
        align: "center"
      },
      {
        label: "材料名称",
        prop: "materialsName",
        align: "center"
      },
      {
        label: "材料要求",
        prop: "materialsRequirements",
        align: "center",
        // render(row) {
        //   return <div style={{ color: "#18388c" }}>{row.materialsRequirements}</div>;
        // }
      },
      {
        label: "原件(份)",
        prop: "original",
        align: "center"
      },
      {
        label: "复印件(份)",
        prop: "copies",
        align: "center"
      },
      {
        label: "范本文件",
        prop: "file",
        align: "center",
        render(row) {
          return (
            <Button style={{ marginLeft: '30px' }} type="text" size="small" onClick={() => window.location = `http://yhbest.imwork.net:30080/blade-portal/articleUtils/downloadSingFile?id=${row.id}`}>
              <img src={download} style={{ marginRight: '5px' }} />
              <span>{row.templateFileName}</span>
            </Button>

          );
        }
      }
    ];




    return (
      <div className="main_search_detail">
        <div className="center" style={{ marginTop: '0' }}>
          <div className="center_search">
            <div className="center_position_info"></div>
            <span style={{ color: "#18388c", fontSize: "24px" }}>
              海棠区办事处优抚补贴申请_
            </span>
            <span style={{ lineHeight: "24px", color: "#18388c" }}>
              办事指南
            </span>
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>事项基本信息</span>
            </div>
          </div>
          <div className="application_info_table tabless">
            <table width="100%" border="1" cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td className="info_td_left">事项名称</td>
                  <td className="info_td_center">{smsEntitledGroups ? smsEntitledGroups.entitledName : ''}</td>
                  <td className="info_td_left">事项类型</td>
                  <td className="info_td_right">{smsEntitledGroups ? smsEntitledGroups.entitledTypeName : ''}</td>
                </tr>
                <tr>
                  <td className="info_td_left">面向对象</td>
                  <td className="info_td_center">
                    {smsEntitledGroups ? smsEntitledGroups.objectName : ''}
                  </td>
                  <td className="info_td_left">办件业务系统</td>
                  <td className="info_td_right">  {smsEntitledGroups ? smsEntitledGroups.doType : ''}</td>
                </tr>
                <tr>
                  <td className="info_td_left">主管部门</td>
                  <td className="info_td_center">
                    {smsEntitledGroups ? smsEntitledGroups.entitledDepartment : ''}
                  </td>
                  <td className="info_td_left">主管部门性质</td>
                  <td className="info_td_right">  {smsEntitledGroups ? this.returnType(this.state.departmentTyprs, smsEntitledGroups.departmentTypr) : ''}</td>
                </tr>
                <tr>
                  <td className="info_td_left">法定办结时限</td>
                  <td className="info_td_center"> {smsEntitledGroups ? smsEntitledGroups.deadlineForCompletion : ''}（工作日）</td>
                  <td className="info_td_left">承诺办结时限</td>
                  <td className="info_td_right"> {smsEntitledGroups ? smsEntitledGroups.limitForCommitment : ''}（工作日）</td>
                </tr>
                <tr>
                  <td className="info_td_left">申请类型</td>
                  <td className="info_td_center"> {smsEntitledGroups ? smsEntitledGroups.doType : ''}</td>
                  <td className="info_td_left">办理形式</td>
                  <td className="info_td_right"> {smsEntitledGroups ? this.returnType(this.state.dealForms, smsEntitledGroups.dealForm) : ''}</td>
                </tr>
                <tr>
                  <td className="info_td_left">费用</td>
                  <td className="info_td_center"> {smsEntitledGroups ? smsEntitledGroups.cost : ''}</td>
                  <td className="info_td_left">中介服务</td>
                  <td className="info_td_right"> {smsEntitledGroups && smsEntitledGroups.intermediaryService == '1' ? '有' : '无'}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>申请条件</span>
            </div>
          </div>
          <div>
            <div className="application_price">
              {smsEntitledGroups ? showhtml(smsEntitledGroups.applicationRequirements) : ''}
            </div>
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>申请办理流程</span>
            </div>
          </div>

          <div className="application_flow">
            <div style={{ marginBottom: "40px" }}>
              <div className="online_process_flow">网上办理流程：</div>
              {smsEntitledGroups ? showhtml(smsEntitledGroups.handleProcess) : ''}
              <Button onClick={() => this.handleClick()}>
                <span style={{ color: "#fff" }}>查看流程图</span>
              </Button>
            </div>
            {/* <div style={{ marginBottom: "40px" }}>
              <div className="online_process_flow">网上办理流程：</div>
              <ul>
                {flowData.map((item, index) => {
                  return (
                    <li>
                      <div className="online_process_flow_title">
                        {index + 1}.<span>{item.title}</span>
                      </div>
                      <div className="online_process_flow_text">
                        {item.text}
                      </div>
                    </li>
                  );
                })}
              </ul>
              <Button onClick={() => this.handleClick()}>
                <span style={{ color: "#fff" }}>查看流程图</span>
              </Button>
            </div> */}
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>材料清单</span>
            </div>
          </div>

          <div style={{ margin: "20px 19px 40px 19px " }}>
            <Table
              style={{ width: "100%" }}
              columns={columns}
              data={materialsList}
              border={true}
            />
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>事项设定依据</span>
            </div>
          </div>
          <div className="application_set_item">
            {smsEntitledGroups ? showhtml(smsEntitledGroups.itemSettingBasis) : ''}
          </div>
        </div>
        {/* 当前位置 */}
        <Dialog
          className="magnifyImgDialog"
          style={{ top: '8%' }}
          visible={this.state.dialogVisible}
          onCancel={() => this.setState({ dialogVisible: false })}
        >
          <Dialog.Body>
            <img src={smsEntitledGroups ? smsEntitledGroups.handleProcessUrl : flowImg} style={{ borderTop: '2px solid #eee' }} />
          </Dialog.Body>
        </Dialog>
      </div>

    );
  }
}
